import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { Button } from './button';

export const ThemeToggle = ({ variant = 'default', size = 'icon', className = '' }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={toggleTheme}
      className={`relative overflow-hidden transition-all duration-300 ${className}`}
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      data-testid="theme-toggle-btn"
    >
      <div className="relative w-5 h-5">
        <Sun 
          className={`absolute inset-0 w-5 h-5 transition-all duration-300 ${
            theme === 'dark' 
              ? 'rotate-0 scale-100 opacity-100' 
              : 'rotate-90 scale-0 opacity-0'
          }`}
        />
        <Moon 
          className={`absolute inset-0 w-5 h-5 transition-all duration-300 ${
            theme === 'light' 
              ? 'rotate-0 scale-100 opacity-100' 
              : '-rotate-90 scale-0 opacity-0'
          }`}
        />
      </div>
    </Button>
  );
};

// Expanded toggle with label
export const ThemeToggleWithLabel = ({ className = '' }) => {
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all w-full
        ${isDark 
          ? 'bg-gray-800/50 hover:bg-gray-700 text-gray-300' 
          : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
        } ${className}`}
      data-testid="theme-toggle-with-label"
    >
      <div className={`p-2 rounded-full ${isDark ? 'bg-yellow-500/20' : 'bg-blue-500/20'}`}>
        {isDark ? (
          <Sun className="w-5 h-5 text-yellow-400" />
        ) : (
          <Moon className="w-5 h-5 text-blue-500" />
        )}
      </div>
      <div className="flex-1 text-left">
        <p className="font-medium">Theme</p>
        <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
          {isDark ? 'Dark Mode' : 'Light Mode'}
        </p>
      </div>
      <div 
        className={`w-12 h-6 rounded-full p-1 transition-colors duration-300 ${
          isDark ? 'bg-purple-600' : 'bg-gray-300'
        }`}
      >
        <div 
          className={`w-4 h-4 rounded-full bg-white shadow-md transform transition-transform duration-300 ${
            isDark ? 'translate-x-6' : 'translate-x-0'
          }`}
        />
      </div>
    </button>
  );
};

export default ThemeToggle;
